import React, { Component } from "react";
import { Row, Col, Button, Alert } from "reactstrap";
import { Link } from "react-router-dom";
import { MdArrowBack } from "react-icons/md";
import Formsy from "formsy-react";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { TextInput, MyCheckbox } from "../Shared/Forms";

import CoreIssuers from "../ISW-Core/Issuers";

import { Spinner } from "../Shared";

import { cardIssuerActions } from "./actions/cardissuers.actions";
import { routeConstants } from "../../_constants";

export class CardIssuerForm extends Component {
  state = {
    canSubmit: false
  };

  componentDidMount() {
    this.getCardIssuer();
  }

  componentWillUnmount() {
    this.props.resetCardIssuer();
  }

  getCardIssuer = () => {
    const { match } = this.props;
    if (match.params && match.params.id) {
      this.props.getCardIssuer(match.params.id);
    }
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.submitted) {
      this.refs.cardIssuerForm.reset();
      if (this.coreIssuers) {
        this.coreIssuers.issuerCode.changeValue(null);
      }
    }
  }

  disableButton = () => {
    this.setState({ canSubmit: false });
  };

  enableButton = () => {
    this.setState({ canSubmit: true });
  };

  createRequest = data => {
    let request = { ...data };
    if (request.issuerCodeObject) {
      request = {
        name: request.issuerCodeObject.name,
        issuerCode: request.issuerCodeObject.code,
        issuerCbnCode: request.issuerCodeObject.cbnCode,
        ...request
      };
      delete request.issuerCodeObject;
    }

    return request;
  };

  handleSubmit = data => {
    let requestBody = this.createRequest(data);

    const { match } = this.props;
    const hasParams = match.params && match.params.id;
    if (hasParams) {
      requestBody = {
        id: match.params.id,
        ...requestBody
      };
    }
    this.props.addCardIssuer(requestBody);
  };

  render() {
    const { canSubmit } = this.state;
    const { submitting, match, viewResponse, viewError, fetched } = this.props;
    const cardIssuer =
      viewResponse && fetched ? viewResponse.modelList[0] : null;
    const hasParams = match.params && match.params.id;
    return (
      <div className="CardIssuerForm">
        <Row>
          <Col sm="6">
            <Link
              className="btn btn-outline btn-primary"
              to={routeConstants.CARDISSUERS.path}
            >
              <MdArrowBack /> Back to list
            </Link>
          </Col>
          <Col sm="6">
            <div className="text-right">
              <h5 className="item-count">
                {hasParams ? "Edit" : "Add"} Card Issuer
                <small>
                  {cardIssuer && hasParams ? `: ${cardIssuer.name}` : null}
                </small>
              </h5>
            </div>
          </Col>
        </Row>
        <hr />
        <Row>
          <Col sm="4">
            {viewError ? (
              <Alert color="danger">
                <strong>Error:</strong> {viewError.message}
              </Alert>
            ) : (
              <Formsy
                ref="cardIssuerForm"
                onValidSubmit={this.handleSubmit}
                onValid={this.enableButton}
                onInvalid={this.disableButton}
                noValidate
              >
                {hasParams ? (
                  <div>
                    <TextInput
                      name="issuerCode"
                      value={
                        cardIssuer && hasParams ? cardIssuer.issuerCode : null
                      }
                      required
                      disabled={submitting || hasParams}
                      title="Card issuer code"
                    />
                    <TextInput
                      name="name"
                      value={cardIssuer && hasParams ? cardIssuer.name : null}
                      required
                      disabled={submitting}
                      title="Card issuer name"
                    />
                    <TextInput
                      name="issuerCbnCode"
                      value={
                        cardIssuer && hasParams
                          ? cardIssuer.issuerCbnCode
                          : null
                      }
                      required
                      disabled={submitting}
                      type="number"
                      title="Card issuer CBN code"
                    />
                  </div>
                ) : (
                  <CoreIssuers
                    value={
                      cardIssuer && hasParams ? cardIssuer.issuerCode : null
                    }
                    innerRef={c => {
                      this.coreIssuers = c;
                    }}
                    disabled={submitting || hasParams}
                    name="issuerCodeObject"
                  />
                )}
                <TextInput
                  name="issuerIin"
                  value={cardIssuer && hasParams ? cardIssuer.issuerIin : null}
                  required
                  disabled={submitting}
                  type="number"
                  title="Card issuer IIN"
                />
                <TextInput
                  name="issuerNr"
                  value={cardIssuer && hasParams ? cardIssuer.issuerNr : null}
                  required
                  disabled={submitting}
                  type="number"
                  title="Card issuer NR"
                />
                <TextInput
                  name="bankCode"
                  value={cardIssuer && hasParams ? cardIssuer.bankCode : null}
                  required
                  disabled={submitting}
                  type="number"
                  title="Bank Code"
                />
                <MyCheckbox
                  name="enabled"
                  title="Enable card issuer"
                  validating={submitting}
                  value={cardIssuer && hasParams ? cardIssuer.enabled : false}
                />
                <Button
                  type="submit"
                  color="primary"
                  disabled={!canSubmit || submitting}
                >
                  {submitting ? <Spinner /> : "Submit"}
                </Button>
              </Formsy>
            )}
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const {
    submitting,
    submitted,
    request,
    response,
    error
  } = state.addCardIssuer;

  const {
    fetching,
    fetched,
    request: viewRequest,
    response: viewResponse,
    error: viewError
  } = state.viewCardIssuer;

  return {
    submitting,
    submitted,
    request,
    response,
    error,
    fetching,
    fetched,
    viewRequest,
    viewResponse,
    viewError
  };
};

const mapDispatchToProps = dispatch => {
  return {
    addCardIssuer: bindActionCreators(
      cardIssuerActions.addCardIssuer,
      dispatch
    ),
    resetCardIssuer: bindActionCreators(
      cardIssuerActions.resetCardIssuer,
      dispatch
    ),
    getCardIssuer: bindActionCreators(cardIssuerActions.getCardIssuer, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CardIssuerForm);
